module.exports = __webpack_public_path__ + "img/hot-tub-person.c36bc213.svg";